import { useState, useEffect, useRef } from "react";
import { Bell, Check, ClipboardList, Clock, MessageCircle } from "lucide-react";
// import {
//   getNotifications,
//   markNotificationAsRead,
// } from "../../utils/firebasefunctions";

import { useStateValue } from "../context/StateProvider";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  getallnotificationswhere,
  getuserinformation,
  updateItem,
} from "../../utils/firebasefunctions";
import { actionType } from "../context/reducer";
import { MdEditDocument, MdDelete } from "react-icons/md";

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationscount, setnotificationscount] = useState(0);
  const dropdownRef = useRef();
  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    getallnotificaitons();
  }, []);

  async function getallnotificaitons() {
    await getallnotificationswhere(
      "notifications",
      "assignedto",
      "==",
      user.id,
      "platform",
      "in",
      ["website", "both"],
    )
      .then(async (response) => {
        let notificationdata = [...response];
        const filterednotificationdata = notificationdata.filter(
          (item) => item?.softdelete != true,
        );

        setNotifications(filterednotificationdata);
        const unreadNotifications = response.filter(
          (n) => n.read !== true && n.softdelete !== true,
        );

        setnotificationscount(unreadNotifications);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const markread = async (id, index) => {
    let data = {
      read: true,
    };
    await updateItem("notifications", id.toString(), data)
      .then(async (response) => {
        let arr = [...notifications];
        arr[index]["read"] = true;
        setNotifications(arr);
        const unreadNotifications = arr.filter((n) => n.read !== true);
        setnotificationscount(unreadNotifications);
      })
      .catch((err) => {
        alert(err);
      });
  };

  const navigate = useNavigate();

  const handleNotificationClick = async (n) => {
    // try {
    //   if (!n.read) {
    //     await markNotificationAsRead(n.id);
    //     // UI update
    //     setNotifications((prev) =>
    //       prev.map((item) =>
    //         item.id === n.id ? { ...item, read: true } : item,
    //       ),
    //     );
    //   }
    //   const param = n.type === "mention" ? `type=chat` : `taskId=${n.taskid}`;
    //   navigate(`/dashboard/deals-detail/${n.dealid}?${param}`);
    // } catch (error) {
    //   console.error("Notification click error:", error);
    // }
  };

  const formatDate = (timestamp) => {
    const date = new Date(Number(timestamp));

    return date.toLocaleString(); // default readable format
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onclickevent = async (item, index) => {
    markread(item.id, index);
    setOpen(false);
    if (
      item.notificationtype == "manualhourrequest" ||
      item.notificationtype == "latereminder" ||
      item.notificationtype == "shiftrequest" ||
      item.notificationtype == "checkoutreminder" ||
      item.notificationtype == "shiftreminder" ||
      item.notificationtype == "expressrequest"
    ) {
      getshiftiddetails(item.shiftid, item.notificationtype);
    } else if (item.notificationtype == "leaverequest") {
      dispatch({
        type: actionType.STORE_SELECTED_TILE,
        payload: "Leave Request",
      });
    } else {
    }
  };

  async function getshiftiddetails(id, type) {
    await getuserinformation("slots", id.toString())
      .then(async (response) => {
        if (type == "expressrequest") {
          navigate("/CreateEmployeeSchedule", {
            state: {
              projectid: response.projectid,
              expressdelivery: true,
              expressshiftdata: response,
              shifttype: "Driver",
            },
          });
        } else {
          dispatch({
            type: actionType.NotificationSlotData,
            payload: response,
          });
          dispatch({
            type: actionType.STORE_SELECTED_TILE,
            payload: "Slots",
          });

          //                              navigate("/slots", {
          //   state: {
          //     shiftdata: response,
          //   },
          // });

          //   let filteredemp =    employees
          //         .filter(function (data) {
          //           return data.id == response.employeeid;
          //         })

          //         props.navigation.navigate('EmployeeCheckinDetails', {
          //                   recordid: response.recordid,
          //                   id: filteredemp[0].id,
          //                   picture: filteredemp[0].profilepicture,
          //                   name: filteredemp[0].firstname + ' ' + filteredemp[0].lastname,
          //                   designation: response.projectdesignation,
          //                   phonenumber: filteredemp[0].phonenumber,
          //                   starttime: response?.starttime,
          //                   endtime: response?.endtime,
          //                   selecteddate: response.sheduleddate,
          //                   projectid: response?.projectid,
          //                   slotdata: response,
          //                   supervisornotes: response?.supervisornotes || '',
          //                 });
        }
      })
      .catch((err) => {
        alert(err);
        // setloading(false);
      });
  }

  const deleteitem = async (item, index) => {
    console.log(JSON.stringify(item));
    let data = {
      softdelete: true,
    };

    await updateItem("notifications", item.id, data)
      .then(async (response) => {
        let dataarray = [...notifications];
        dataarray.splice(index, 1);
        // dataarray[index]["softdelete"] = true
        setNotifications(dataarray);
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        onClick={() => setOpen(!open)}
        className=" drop-shadow-lg text-lighttextGray hover:text-white p-[14px]  rounded-full cursor-pointer relative    bg-themelightblack hover:bg-themeblue transition"
      >
        <Bell className="   size-4 lg:size-4" />

        {notificationscount.length > 0 && (
          <div className="bg-red-500 text-white rounded-full size-4 flex items-center justify-center text-xs absolute -top-1 -right-1">
            {notificationscount.length}
          </div>
        )}
      </div>

      {open && (
        <div className="absolute right-0 mt-1 w-80 lg:w-96  bg-themelightblack rounded-2xl shadow-xl  z-50  border border-white/20 hover:border-themegreen overflow-hidden">
          <div className="p-4 ">
            <h3 className="font-semibold text-white text-lg PoppinsRegular">
              Notifications
            </h3>
          </div>

          <div className="max-h-80 overflow-y-auto">
            {notifications.length > 0 ? (
              notifications.map((n, index) => (
                <div className="w-full flex flex-row items-center">
                  <div className=" text-themedarkgrey size-3 flex items-center justify-center rounded-full shrink-0 group-hover:scale-105 transition w-[10%]">
                    <MdDelete
                      onClick={() => {
                        deleteitem(n, index);
                      }}
                      className=" text-lighttextGray hover:text-red-500   w-[20px] h-[20px] hover:cursor-pointer"
                    />
                  </div>

                  <div
                    key={n.id}
                    onClick={() => onclickevent(n, index)}
                    className="px-4 py-2 hover:bg-themeblue  cursor-pointer flex items-center justify-between gap-x-2 w-[90%]"
                  >
                    <div className="flex items-center gap-x-2 ">
                      {/* {n.type === "deadline" ? (
                      <div className="bg-[#EEF2FF] text-red-500 size-8 flex items-center justify-center rounded-full shrink-0 group-hover:scale-105 transition">
                        <Clock size={18} />
                      </div>
                    ) : n.type === "mention" ? (
                      <div className="bg-[#EEF2FF] text-[#1E293B] size-8 flex items-center justify-center rounded-full shrink-0 group-hover:scale-105 transition">
                        <MessageCircle size={18} />
                      </div>
                    ) : (
                      <div className="bg-[#EEF2FF] text-[#1E293B] size-8 flex items-center justify-center rounded-full shrink-0 group-hover:scale-105 transition">
                        <ClipboardList size={18} />
                      </div>
                    )} */}

                      <div className="text-left">
                        <h4 className="text-xs lg:text-sm font-medium text-white PoppinsRegular">
                          {n.title}
                        </h4>
                        <p className="text-white text-xs PoppinsRegular">
                          {n.message}
                        </p>
                        <p className="text-[10px] text-white/80 PoppinsRegular">
                          {moment(n.id).fromNow()}
                        </p>
                      </div>
                    </div>
                    {n.read !== true && (
                      <div className=" text-green-500 size-3 flex items-center justify-center rounded-full shrink-0 group-hover:scale-105 transition">
                        <div className="size-2 rounded-full bg-themegreen"></div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="p-4 text-center text-sm text-gray-500">
                No notifications
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
